"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHelpfulLinks = exports.getAdditionalLinks = exports.getSupportQuestions = void 0;
var getSupportQuestions_1 = __importDefault(require("./getSupportQuestions"));
exports.getSupportQuestions = getSupportQuestions_1.default;
var getAdditionalLinks_1 = __importDefault(require("./getAdditionalLinks"));
exports.getAdditionalLinks = getAdditionalLinks_1.default;
var getHelpfulLinks_1 = __importDefault(require("./getHelpfulLinks"));
exports.getHelpfulLinks = getHelpfulLinks_1.default;
